import { ReactNode, useEffect } from "react";

type NativeContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  disableBottomSafeArea?: boolean;
  themeColor?: string;
};

const NativeContainer = ({
  children,
  className = "",
  disableBottomSafeArea = false,
  themeColor,
  ...props
}: NativeContainerProps) => {
  useEffect(() => {
    if (!themeColor) return;
    let meta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "theme-color";
      document.head.appendChild(meta);
    }
    const prev = meta.content;
    meta.content = themeColor;
    return () => { meta.content = prev; };
  }, [themeColor]);

  return (
    <div
      className={className}
      style={{
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: disableBottomSafeArea ? 0 : "env(safe-area-inset-bottom)",
        ...props.style,
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export default NativeContainer;
